module.exports = __webpack_public_path__ + "static/media/bike2.7f103802.jpg";